import { registerLanguage } from '../_.contribution.js';

registerLanguage({
  id: "azcli",
  extensions: [".azcli"],
  aliases: ["Azure CLI", "azcli"],
  loader: () => import('./azcli.js')
});
